import React from "react";
import Login from "../../authentication/Login";
import ForgotYourPassword from "../../authentication/ForgotYourPassword";
import PasswordResetConfirm from "../../authentication/PasswordResetConfirm";
import { Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import AccountDeactivated from "../universalPages/AccountDeactivated";

const unAnthenticatedRoutes = [
  <Route index path="/login" key="login" element={<Login />} />,
  <Route index path="/" key="login-ex" element={<Login />} />,
  <Route
    key="forgot-password"
    path="/forgot-your-password"
    element={<ForgotYourPassword />}
  />,
  <Route
    key="password-confirm"
    path="/password-confirm"
    element={<PasswordResetConfirm />}
  />,
  <Route key="account-deactivated" path="*" element={<AccountDeactivated />} />
];

export default unAnthenticatedRoutes;